import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)({
    backgroundColor: '#202020',
    color: '#fff',
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    padding: '1.5rem',
    marginBottom: '20px',
    flex: 1, // Ensures it takes equal space in flexbox
});

const RevenueToDate = () => {
    const facility = {
        revenue: '$1,200,000',
    };

    return (
        <StyledCard>
            <CardContent>
                <Typography variant="h6">Revenue to Date</Typography>
                <Typography variant="h4" color="#12c099">{facility.revenue}</Typography>
            </CardContent>
        </StyledCard>
    );
};

export default RevenueToDate;
